import styled from 'styled-components';
import { Tab } from '../../../icons';
export const TabIcon = styled(Tab).attrs({ height: '16px', width: '16px' }) ``;
export const TabIconContainer = styled.div `
  display: flex;
  margin-right: 8px;
`;
//# sourceMappingURL=styles.js.map